import React, {Component, Fragment} from 'react';
import AppConfig from "../../helpers/AppConfig";
import SidebarElements from '../../components/SidebarPanel/SidebarElements';
import ClassNames from '../../enums/ClassNames';

export default class Header extends Component {
    componentDidMount() {
        document.querySelector('.overlay')?.addEventListener("click", this.closeHamburgerMenu);
    }

    render() {
        return (
            <Fragment>
                <header className="header header--secondary container d-flex align-items-center justify-content-center d-sm-none">
                    {/* Logo */}
                    <div className="logo col-6 d-sm-none">
                        <a href="/" className="logo__link">
                            <img src={AppConfig.PowFormUrl + "/images/logo-simple.svg"} alt="Powform logo" className="logo__img" />
                        </a>
                    </div>

                    {/* Toggle hamburger menu */}
                    <div className="col-6 d-flex justify-content-end d-sm-none">
                        <div className="hamburger-menu menu-toggle" onClick={this.openHamburgerMenu}>
                            <span className="menu-toggle__item"></span>
                            <span className="menu-toggle__item"></span>
                            <span className="menu-toggle__item"></span>
                        </div>
                    </div>
                </header>

                {/* Sidebar hamburger */}
                <div className="sidebar sidebar--hamburger d-flex justify-content-between flex-column d-sm-none js-menu-wrapper">
                    <a href="/" className="sidebar__close" title="Close menu" onClick={this.closeHamburgerMenu}>
                        <svg className="icon-svg"><use href="#close"></use></svg>
                    </a>

                    <div className="sidebar__inner">
                        <SidebarElements />
                    </div>

                    <div className="sidebar-actions">
                        <a href={AppConfig.PowFormUrl + "/help"} className="sidebar-actions__link" title="Help">
                            <svg className="icon-svg"><use href="#infoOutlined"></use></svg>
                            <span className="sidebar-actions__text">Help</span>
                        </a>
                    </div>
                </div>
            </Fragment>
        )
    }

    private openHamburgerMenu = (e: any) => {
        e.preventDefault();
        e.stopPropagation();

        document.querySelector('.js-menu-wrapper')?.classList.add(ClassNames.SidebarMenuOpened);
        document.body.classList.add(ClassNames.OverlayVisible);
    }

    private closeHamburgerMenu = (e: any) => {
        e.preventDefault();
        e.stopPropagation();

        if (document.body.classList.contains(ClassNames.OverlayVisible)) {
            document.querySelector('.js-menu-wrapper')?.classList.remove(ClassNames.SidebarMenuOpened);
            document.body.classList.remove(ClassNames.OverlayVisible);
        }
    }
}